import * as React from 'react'

import { StyledLabel } from './Label.glamorous'

export const Label: React.SFC<React.LabelHTMLAttributes<HTMLLabelElement>> = (props) => {
  return <StyledLabel {...props} />
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/Input/components/Label/Label.tsx